<template>
  <div id="app">
    <header class="header">
      <div class="logo">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="166" height="23" viewBox="0 0 166 23">
          <defs><path id="a" d="M.039.554h165.39v22.102H.038z"/></defs>
          <g fill="none" fill-rule="evenodd">
            <g>
              <mask id="b" fill="#fff"><use xlink:href="#a"/></mask>
              <path fill="#FFFFFE" d="M164.961 2.432H67.56l.46-1.878h97.41l-.468 1.878M58.036 22.695H0l.466-1.876h58.037l-.467 1.876M74.232 10.727l-.433 1.784h-4.303l-1.808 7.23c-.05.17-.076.315-.076.434 0 .425.263.636.79.636h2.24c.934 0 1.68-.093 2.24-.28l-.941 2.164h-6.494c-1.51 0-2.266-.697-2.266-2.087 0-.373.06-.79.178-1.249l1.708-6.848.432-1.784.611-2.445 4.583-.584-.764 3.03h4.303M87.202 13.428a1.35 1.35 0 0 0 .05-.332c0-.322-.193-.484-.582-.484h-3.975c-.491 0-.805.272-.94.816l-.637 2.495h5.448l.636-2.495zm4.329.381l-.993 3.997H80.66l-.56 2.191c-.034.136-.05.246-.05.33 0 .322.194.484.584.484h7.817c.41 0 .866-.05 1.375-.152l-.866 2.036H77.934c-1.544 0-2.316-.653-2.316-1.961 0-.322.05-.696.153-1.119l1.45-5.806c.51-2.054 1.74-3.082 3.693-3.082h8.452c1.546 0 2.318.655 2.318 1.962 0 .323-.05.695-.153 1.12zM106.383 10.727l-.66 2.649c-.732-.17-1.622-.254-2.675-.254h-1.934c-.527 0-.858.27-.994.814l-1.604 6.417c-.22.882-.33 1.663-.33 2.342h-4.94c.372-.797.653-1.579.841-2.342l1.782-7.206c.237-.968.356-1.773.356-2.42h4.252l-.153 1.3h.05c.306-.866 1.062-1.3 2.268-1.3h3.741M119.015 10.727l-.663 2.649c-.73-.17-1.62-.254-2.674-.254h-1.934c-.526 0-.858.27-.994.814l-1.604 6.417c-.22.882-.33 1.663-.33 2.342h-4.94c.373-.797.653-1.579.84-2.342l1.783-7.206c.236-.968.356-1.773.356-2.42h4.25l-.15 1.3h.05c.305-.866 1.061-1.3 2.266-1.3h3.744M129.676 16.279h-4.711c-.492 0-.806.27-.942.814l-.739 2.929c-.033.135-.05.246-.05.33 0 .307.17.459.51.459h4.049c.49 0 .804-.262.94-.79l.943-3.742zm5.04-2.443l-1.705 6.772a8.63 8.63 0 0 0-.254 2.087h-4.05v-1.247c-.525.832-1.16 1.247-1.909 1.247h-5.729c-1.441 0-2.163-.68-2.163-2.036 0-.493.084-1.105.254-1.835l.129-.559c.305-1.375.767-2.364 1.386-2.965.62-.604 1.463-.906 2.533-.906h6.315c.407 0 .663-.185.764-.558l.203-.817c.085-.338-.074-.508-.483-.508h-7.004c-.474 0-1.111.084-1.908.255l.79-2.039h10.617c1.58 0 2.37.655 2.37 1.962 0 .339-.052.722-.156 1.147zM145.436 6.705l-.714 2.851h-4.429l.712-2.85h4.431zm-1.02 4.022l-2.392 9.626c-.222.882-.331 1.663-.331 2.342h-4.94a12.77 12.77 0 0 0 .84-2.342l1.783-7.206c.238-.968.357-1.773.357-2.42h4.684zM162.153 13.836l-1.628 6.517c-.222.882-.331 1.663-.331 2.342h-4.94c.373-.78.653-1.56.84-2.342l1.732-6.925c.033-.119.051-.23.051-.332 0-.322-.213-.484-.637-.484h-3.718c-.527 0-.857.272-.993.816l-1.73 6.925c-.223.882-.332 1.663-.332 2.342h-4.94c.373-.797.654-1.579.84-2.342l1.782-7.206c.239-.968.356-1.773.356-2.42h4.432l-.203 1.223h.048c.426-.814.995-1.223 1.708-1.223h5.55c1.511 0 2.267.655 2.267 1.962 0 .339-.051.722-.154 1.147" mask="url(#b)"/>
            </g>
            <path fill="#FFFFFE" d="M51.808 12.523l.432-1.784h4.303l1.807-7.23c.052-.17.077-.314.077-.432 0-.426-.263-.636-.79-.636h-2.24c-.933 0-1.68.091-2.24.28l.941-2.165h6.493c1.511 0 2.267.696 2.267 2.086 0 .375-.06.791-.179 1.25l-1.705 6.847-.433 1.784-.612 2.446-4.583.585.764-3.03h-4.302M38.912 9.823c-.034.135-.05.246-.05.333 0 .32.195.484.585.484h3.972c.493 0 .807-.274.943-.817l1.654-6.568c.035-.137.052-.247.052-.33 0-.322-.195-.484-.586-.484H41.51c-.492 0-.806.27-.942.814l-1.656 6.568zm-4.328-.38l1.451-5.807c.509-2.054 1.741-3.08 3.692-3.08h8.453c1.545 0 2.318.653 2.318 1.962 0 .322-.05.694-.153 1.118l-1.452 5.807c-.508 2.054-1.739 3.08-3.691 3.08h-8.454c-1.544 0-2.317-.654-2.317-1.961 0-.323.051-.695.153-1.12zM15.584 12.523l2.369-9.549c.238-.949.356-1.757.356-2.418h4.43l-.204 1.221h.051c.425-.814.994-1.221 1.706-1.221h5.551c1.51 0 2.266.653 2.266 1.962 0 .338-.05.719-.152 1.144l-1.63 6.52c-.22.882-.33 1.662-.33 2.341H25.31l2.318-9.268c.033-.12.05-.23.05-.33 0-.322-.212-.484-.637-.484h-3.717c-.525 0-.857.27-.993.814l-1.731 6.926c-.22.883-.331 1.663-.331 2.342h-4.686M2.508 12.523l.433-1.784h4.303L9.05 3.51c.052-.17.076-.314.076-.432 0-.426-.262-.636-.789-.636h-2.24c-.933 0-1.68.091-2.242.28L4.8.555h6.493c1.51 0 2.266.696 2.266 2.086 0 .375-.059.791-.178 1.25l-1.706 6.847-.433 1.784-.611 2.446-4.583.585.763-3.03H2.508"/>
          </g>
        </svg>
      </div>
    </header>
    <nav class="navbar navbar-expand bg-white sticky-top" id="nav" v-if="bikeSelected === 1">
      <div class="container">
        <div class="navbar-prev">
          <button class="navbar-prev-button" v-on:click="onClickPrevButton"><i class="fas fa-chevron-left"></i></button>
        </div>
        <div class="navbar-next">
          <button class="navbar-next-button" v-on:click="onClickNextButton"><i class="fas fa-chevron-right"></i></button>
        </div>
        <div id="navbarNav">
          <ul class="navbar-nav" v-scroll-spy-active="{selector: 'li.nav-item', class: 'active'}">
            <router-link tag="li" to="/" v-scroll-to="'#personalize'" v-on:click.native="onClickNav()" class="nav-item mr-lg-2">
              <a class="nav-link" :id="$t('navigation.step1')">{{ $t('navigation.step1') }}</a>
              <div class="nav-seperator"></div>
            </router-link>

            <router-link tag="li" to="/#equipment" v-scroll-to="'#equipment'" v-on:click.native="onClickNav()" class="nav-item mr-lg-2">
              <a class="nav-link" :id="$t('navigation.step2')">{{ $t('navigation.step2') }}</a>
              <div class="nav-seperator"></div>
            </router-link>

            <li v-if="getNavState" :class="getNavState" class="nav-item mr-lg-2">
              <a class="nav-link" :id="$t('navigation.step3')">{{ $t('navigation.step3') }}</a>
              <div class="nav-seperator"></div>
            </li>
            <router-link v-else tag="li" to="/#more_options" v-scroll-to="'#more_options'" v-on:click.native="onClickNav()" class="nav-item mr-lg-2">
              <a class="nav-link" :id="$t('navigation.step3')">{{ $t('navigation.step3') }}</a>
              <div class="nav-seperator"></div>
            </router-link>

            <li v-if="getNavState" :class="getNavState" class="nav-item mr-lg-2">
              <a class="nav-link" :id="$t('navigation.step4')">{{ $t('navigation.step4') }}</a>
              <div class="nav-seperator"></div>
            </li>
            <router-link v-else tag="li" to="/accessories" v-scroll-to="'#accessories'" v-on:click.native="onClickNav()" class="nav-item mr-lg-2">
              <a class="nav-link" :id="$t('navigation.step5')">{{ $t('navigation.step4') }}</a>
              <div class="nav-seperator"></div>
            </router-link>

            <li v-if="getNavState" :class="getNavState" class="nav-item mr-lg-2">
              <a class="nav-link" :id="$t('navigation.step5')">{{ $t('navigation.step5') }}</a>
              <div class="nav-seperator"></div>
            </li>
            <router-link v-else tag="li" to="/your-bike" v-scroll-to="'#your_bike'" v-on:click.native="onClickNav()" :class="getNavState" class="nav-item mr-lg-2">
              <a class="nav-link" :id="$t('navigation.step5')">{{ $t('navigation.step5') }}</a>
              <div class="nav-seperator"></div>
            </router-link>

            <li class="nav-slide"></li>
          </ul>
        </div>
      </div>
    </nav>
    <router-view/>
    <footer class="footer bg-white fixed-bottom" id="footer" v-if="bikeSelected === 1">
      <div class="container d-flex justify-content-between flex-nowrap">
        <div>
          <div v-if="price">
            <b class="footer-price">{{ price }}*</b><br/>

            <span v-if="vat" class="footer-price-info small">
              <p v-html="$t('footer.priceInfoText')"></p>
            </span>

            <span v-else class="footer-price-info small">
              <p v-html="$t('footer.priceInfoTextExcl')"></p>
            </span>
          </div>
        </div>
        <div>
          <button type="button" class="btn btn-secondary footer-btn d-none" v-on:click="prevStep" id="backButton" v-if="!getNavState">{{ $t('footer.backButton') }}</button>
          <button type="button" class="btn btn-primary footer-btn" v-on:click="nextStep" id="nextButton" v-if="getNavState && step === 0 || !getNavState">{{ $t('footer.nextButton') }}</button>
          <button type="button" class="btn btn-secondary footer-btn" onclick="print()" id="printButton" v-if="!getNavState && step === 4"><i class="fal fa-print mr-2"></i> {{ $t('yourBike.printLink') }}</button>
          <input type="hidden" id="step" v-model="step" />
        </div>
      </div>
    </footer>

    <div v-if="popupSuccess" class="alert alert-success fixed-top" style="margin-top: 70px;">
      <div class="container">
        <div class="alert-icon">
          <i class="material-icons">check</i>
        </div>
        <button type="button" class="close" v-on:click="popupSuccess = !popupSuccess">
          <span aria-hidden="true"><i class="material-icons">clear</i></span>
        </button>
        <b>Success:</b> {{ popupSuccessText }}
      </div>
    </div>

    <div v-if="popupInfo" class="alert alert-warning fixed-top" style="margin-top: 50px;">
      <div class="container">
        <div class="alert-icon">
          <i class="material-icons">info_outline</i>
        </div>
        <button type="button" class="close" v-on:click="popupInfo = !popupInfo">
          <span aria-hidden="true"><i class="material-icons">clear</i></span>
        </button>
        <b>Info:</b> <span v-html="popupInfoText"></span>
      </div>
    </div>

    <div v-if="popupError" class="alert alert-danger fixed-top" style="margin-top: 70px;">
      <div class="container">
        <div class="alert-icon">
          <i class="material-icons">error_outline</i>
        </div>
        <button type="button" class="close" v-on:click="popupError = !popupError">
          <span aria-hidden="true"><i class="material-icons">clear</i></span>
        </button>
        <b>Error:</b> Connection could not be established. Please reload the configurator. <a :href="'/?bike=' + bikeName + '&lang=' + '&country=' + countryCode" class="btn btn-sm">Reload</a>
      </div>
    </div>

    <transition name="fade">
      <div v-if="loading" class="loading-bg">
        <div class="dank-ass-loader">
          <div class="row">
            <div class="arrow up outer outer-18"></div>
            <div class="arrow down outer outer-17"></div>
            <div class="arrow up outer outer-16"></div>
            <div class="arrow down outer outer-15"></div>
            <div class="arrow up outer outer-14"></div>
          </div>
          <div class="row">
            <div class="arrow up outer outer-1"></div>
            <div class="arrow down outer outer-2"></div>
            <div class="arrow up inner inner-6"></div>
            <div class="arrow down inner inner-5"></div>
            <div class="arrow up inner inner-4"></div>
            <div class="arrow down outer outer-13"></div>
            <div class="arrow up outer outer-12"></div>
          </div>
          <div class="row">
            <div class="arrow down outer outer-3"></div>
            <div class="arrow up outer outer-4"></div>
            <div class="arrow down inner inner-1"></div>
            <div class="arrow up inner inner-2"></div>
            <div class="arrow down inner inner-3"></div>
            <div class="arrow up outer outer-11"></div>
            <div class="arrow down outer outer-10"></div>
          </div>
          <div class="row">
            <div class="arrow down outer outer-5"></div>
            <div class="arrow up outer outer-6"></div>
            <div class="arrow down outer outer-7"></div>
            <div class="arrow up outer outer-8"></div>
            <div class="arrow down outer outer-9"></div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>

  // https://rest.logik-gmbh.de
  // https://api.tout-terrain.de
  // https://api-testkonfig.tout-terrain.de
  Vue.prototype.$apiurl = 'https://api-testkonfig.tout-terrain.de';
  Vue.prototype.$apikey = 'MKM$b+rVW@VC9vH+';
  Vue.prototype.$apipassword = generateApiPassword();

  function generateApiPassword() {
    let apiPassword = 'ab!j_XG*UWE?y53#yyX6DcnY2Pu6u2-S';
    let timestamp = new Date();
    let year = timestamp.getFullYear();
    let month = timestamp.getMonth();
    let day = timestamp.getDate();
    let hour = timestamp.getHours();
    let date = new Date(year,month,day,hour,'00','00');
    let dateToTimestamp = Date.parse(date);
    dateToTimestamp = dateToTimestamp / 1000;
    apiPassword += dateToTimestamp;
    apiPassword = md5(apiPassword);

    return apiPassword;
  }

  import md5 from 'js-md5'

  export default {
    name: 'app',
    data() {
      return {
        step: 0,
        price: 0,
        priceSymbol: '',
        vat: 0,
        nav: false,
        lang: 1,
        countryCode: 'de',
        loading: false,
        ConfigurationID: '',
        channel: 'b2c',
        customerID: '',
        destination: 'shopware',
        cartId: null,
        shopDomain: '',

        // popups
        popupSuccess: false,
        popupSuccessText: '',
        popupError: false,
        popupInfo: false,
        popupInfoText: '',

        bikeName: '',
        bikeSelected: 0
      }
    },
    computed: {
      getNavState() {
        if(this.nav === true) {
          return '';
        } else {
          return 'nav-item-disabled';
        }
      }
    },
    
    created() {
      // Store Vue instance for access in global function
      const vueApp = this;
      
      // Populate the global function that was created in main.js
      window.handleSmartFitSelect = function(event) {
        if (!event || !event.detail) {
          return;
        }
        
        const { code, stock } = event.detail;

        vueApp.loading = true;

        // code enthält die variant-id oder global-id
        let size = code;

        let params = new URLSearchParams();
        params.append('apikey', vueApp.$apikey);
        params.append('apipassword', vueApp.$apipassword);
        params.append('ConfigurationID', vueApp.ConfigurationID);
        params.append('Characteristic', "Rahmengröße");
        params.append('Value', size);
        
        vueApp.$children[0].$refs.selectButtons_Rahmengröße[0].$children[0].$children[0].selected = true;
        vueApp.$children[0].$refs.selectButtons_Rahmengröße[0].$children[0].$children[0].selectedItem = size;
        vueApp.$children[0].$refs.selectButtons_Rahmengröße[0].$children[0].$children[0].defaultOptions.items.preSelected = size;

        vueApp.buttonSelectedPost(vueApp,params);
      };
    },
    mounted() {
      // Load SmartFit widget script
      const js = document.createElement('script');
      js.type = 'module';
      js.src = 'https://widget3.smartfit.online/?apiKey=oz_KAa81I3LBhew6/jUeccveedrcwo8rbYBXiY/OvkcBqwIfQiE63NV2';
      js.async = true;
        
      const scripts = document.getElementsByTagName('script');
      const lastScript = scripts[scripts.length - 1];
      lastScript.parentNode.insertBefore(js, lastScript);
    

      // navbar scroll mobil
      $(".navbar-nav").scroll(function() {
        if($(this).scrollLeft() + $(this).innerWidth() >= $(this)[0].scrollWidth - 1) {
          $('.navbar .navbar-next').css('display', 'none');
          $('.navbar .navbar-prev').css('display', 'block');
          $('#navbarNav').css('padding-right', '0').css('padding-left','45px');
        } else {
          $('.navbar .navbar-next').css('display', 'block');
          $('.navbar .navbar-prev').css('display', 'none');
          $('#navbarNav').css('padding-right', '45px').css('padding-left','0');
        }
      });

      const path = this.$router.history.current.path;
      const hash = this.$router.history.current.hash;

      if(path === "/" && hash === "") {
        this.step = 0;
      } else if(path === "/" && hash === "#equipment") {
        this.step = 1;
        setTimeout(function() {
          $( '#backButton' ).removeClass('d-none');
          $( '#toCart' ).addClass('d-none');
          VueScrollTo.scrollTo('#equipment')
        }, 3000)
      } else if(path === "/" && hash === "#more_options") {
        this.step = 2;
        setTimeout(function() {
          $( '#backButton' ).removeClass('d-none');
          $( '#toCart' ).addClass('d-none');
          VueScrollTo.scrollTo('#more_options')
        }, 3000)
      } else if(path === "/accessories" && hash === "") {
        this.step = 3;
        setTimeout(function() {
          $('#backButton').removeClass('d-none');
          $( '#toCart' ).addClass('d-none');
        }, 1)
      } else if(path === "/your-bike" && hash === "") {
        this.step = 4;
        setTimeout(function() {
          $( '#nextButton' ).addClass('d-none');
          $( '#toCart' ).removeClass('d-none');
        }, 1)
      }
    },
    methods: {
      onClickPrevButton: function() {
        let leftPos = $('.navbar-nav').scrollLeft();
        $(".navbar-nav").animate({scrollLeft: leftPos - 480}, 500);
        $('.navbar .navbar-next').css('display', 'block');
        $('.navbar .navbar-prev').css('display', 'none');
        $('#navbarNav').css('padding-right', '45px').css('padding-left','0');
      },
      onClickNextButton: function() {
        let leftPos = $('.navbar-nav').scrollLeft();
        $(".navbar-nav").animate({scrollLeft: leftPos + 480}, 500);
        $('.navbar .navbar-next').css('display', 'none');
        $('.navbar .navbar-prev').css('display', 'block');
        $('#navbarNav').css('padding-right', '0').css('padding-left','45px');
      },
      onClickNav: function() {
        const path = this.$router.history.current.path;
        const hash = this.$router.history.current.hash;

        if(path === "/" && hash === "") {
          this.step = 0;
          $( '#backButton' ).addClass('d-none');
          $( '#nextButton' ).removeClass('d-none');
          $( '#toCart' ).addClass('d-none');
          setTimeout(function() {
            VueScrollTo.scrollTo('#personalize')
          }, 1000)
        } else if(path === "/" && hash === "#equipment") {
          this.step = 1;
          $( '#backButton' ).removeClass('d-none');
          $( '#nextButton' ).removeClass('d-none');
          $( '#toCart' ).addClass('d-none');
          setTimeout(function() {
            VueScrollTo.scrollTo('#equipment')
          }, 1000)
        } else if(path === "/" && hash === "#more_options") {
          this.step = 2;
          $( '#backButton' ).removeClass('d-none');
          $( '#nextButton' ).removeClass('d-none');
          $( '#toCart' ).addClass('d-none');
          setTimeout(function() {
            VueScrollTo.scrollTo('#more_options')
          }, 1000)
        } else if(path === "/accessories" && hash === "") {
          this.step = 3;
          $( '#backButton' ).removeClass('d-none');
          $( '#nextButton' ).removeClass('d-none');
          $( '#toCart' ).addClass('d-none')
        } else if(path === "/your-bike" && hash === "") {
          this.step = 4;
          $( '#backButton' ).addClass('d-none');
          $( '#nextButton' ).addClass('d-none');
          $( '#toCart' ).removeClass('d-none')
        }
      },
      prevStep: function (event) {
        if(this.step > 0) this.step = this.step - 1;

        if(this.step === 0) {
          $( '#backButton' ).addClass('d-none');
          this.$router.push({ path: '/' }, function () {
            VueScrollTo.scrollTo('#personalize')
          })
        }

        if(this.step === 1) {
          this.$router.push({ path: '/#equipment' }, function () {
            setTimeout(function() {
              VueScrollTo.scrollTo('#equipment')
            }, 1)
          })
        } else if(this.step === 2) {
          this.$router.push({ path: '/#more_options' }, function () {
            setTimeout(function() {
              VueScrollTo.scrollTo('#more_options')
            }, 3000)
          })
        } else if(this.step === 3) {
          this.$router.push({ path: 'accessories' });
          VueScrollTo.scrollTo('#accessories')
        } else if(this.step === 4) {
          this.$router.push({ path: 'your-bike' });
          VueScrollTo.scrollTo('#your_bike')
        }
      },
      nextStep: function (event) {
        this.step = this.step + 1;

        if(this.step === 1) {
          $( '#backButton' ).removeClass('d-none');
          this.$router.push({ path: '/#equipment' }, function() {
            VueScrollTo.scrollTo('#equipment')
          })
        } else if(this.step === 2) {
          this.$router.push({ path: '/#more_options' }, function() {
            VueScrollTo.scrollTo('#more_options')
          })
        } else if(this.step === 3) {
          this.$router.push({ path: 'accessories' }, function() {
            $( '#backButton' ).removeClass('d-none');
            setTimeout(function() {
              VueScrollTo.scrollTo('#accessories')
            }, 1)
          })
        } else if(this.step === 4) {
          $( '#backButton' ).addClass('d-none');
          $( '#nextButton' ).addClass('d-none');
          $( '#toCart' ).removeClass('d-none');
          this.$router.push({ path: 'your-bike' }, function() {
            setTimeout(function() {
              VueScrollTo.scrollTo('#your_bike')
            }, 1)
          })
        }
      },
      toCart: function() {
        console.log('to cart');
      },
      buttonSelectedPost(app,params) {
        this.$http.post(this.$apiurl + '/api/SetValue', params)
          .then(response => {
              if(response.data['TransferData']['ConfigurationID']) {
                app.ConfigurationID = response.data['TransferData']['ConfigurationID'];
              } 
              app.loading = false;
              app.step = 1;
          })
          .catch(error => {
            console.log(error);
            app.buttonSelectedPost(app,params);
          })
      }
    },
  }
</script>

<style scoped>
  #app .header {
    height: 76px;
    background-color: #131313;
    border-bottom: 6px solid #ec7205;
    text-align: center;
  }
  #app .header .logo {
    display: inline-block;
    height: 76px;
    line-height: 76px;
  }
  #app .footer {
    height: 80px;
    box-shadow: 0 2px 30px 0 rgba(0, 0, 0, 0.3);
  }
  #app .footer .footer-price {
    font-size: 20px;
  }
  #app .footer .btn-primary {
    background-color: #ec7205;
    clip-path: polygon(10% 0, 100% 0%, 90% 100%, 0% 100%);
  }
  @media (max-width: 575.98px) {
    #app .footer .btn-secondary {
      display: none;
    }
  }
  #app .footer .btn-secondary {
    color: white;
    background-color: #000000;
    clip-path: polygon(10% 0, 100% 0%, 90% 100%, 0% 100%);
  }
  #app .loading-bg {
    position: fixed;
    height: 100%;
    width: 100%;
    z-index: 1500;
    background: rgba(0,0,0,0.5);
    top: 0;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  #app .alert {
    z-index: 1501;
  }
  #app .alert.alert-warning {
    background-color: #ec7205;
  }
</style>
